import { Box, Button, Typography } from "@mui/material";
import Layout from "../templates/Layout";
import { useAppNavigate } from "../../routes/useAppNavigate";

const ForbiddenPage = () => {
  const { authenticatedNavigate } = useAppNavigate();
  return (
    <Layout title="403 Forbidden" disableBack>
      <Box textAlign={"center"}>
        <Typography mb={10} variant="h3">
          403
        </Typography>
        <Typography mb={10}>
          アクセスが拒否されました。このページにアクセスする権限がありません。
        </Typography>
        <Button
          sx={{ maxWidth: "sm" }}
          variant="contained"
          fullWidth
          onClick={() => authenticatedNavigate.root()}
        >
          ホームに戻る
        </Button>
      </Box>
    </Layout>
  );
};

export default ForbiddenPage;
